import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const CountryField: React.FC<FieldComponentProps> = ({ field, name, disabled, countries }) => {
  const { control, setValue } = useFormContext()
  const { t } = useTranslation()
  const required = !disabled && Boolean(field.fieldRequired)

  return (
    <FormFields.Select
      control={control}
      disabled={disabled}
      placeholder={'-'}
      search={!disabled}
      name={`${name}.value`}
      rules={required ? {
        required: {
          value: true,
          message: t('Please select Country')
        }
      } : {}}
      onChange={(e, data) => setValue(`${name}.value`, data.value)}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      options={countries?.map(country => ({ value: country.id, text: country.label, flag: country.iso }))}
    />
  )
}

export default CountryField
